import React, { useState } from "react";
import "./style.css";
import { IoArrowBackOutline } from "react-icons/io5";
import ToggleSwitch from "../components/toggleSwitch";
import { useNavigate, useLocation } from "react-router";
import icon from "../assets/Icon.png";
import { url } from "../env";
import Loader from "../components/loader";
import { getDelawareDate } from "../env";
import Footer from "../components/footer";


export default function Attendance() {

    const [loading,isLoading] = useState(false);

    const location = useLocation();
    const state = location.state;
    console.log(state);
    function getLastThreeDigits(id) {
        // Split the ID string by hyphens and get the last part
        const parts = id.split('-');
        return parts[parts.length - 1]; // Return the last part (the last 3 digits)
    }



    const [attendanceData, setAttendanceData] = useState(location.state.students);

    const handleToggle = (rollNo) => {
        setAttendanceData((prevData) =>
            prevData.map((student) =>
                student.rollNo === rollNo
                    ? { ...student, status: student.status === "absent" ? "present" : "absent" }
                    : student
            )
        );
    };
    console.log(attendanceData, "students")
    const navigate = useNavigate();




    const updateAttendance = async () => {
        try {
            // Start the loading state
            isLoading(true);
    
            // Define the API endpoint
            const endpoint = `${url}course-attendance/add`;
    
            // Prepare the request payload
            const payload = {
                courseId: location.state.courseId,
                courseName: location.state.courseName,
                attendanceDate: getDelawareDate(),
                attendanceData:attendanceData, // Include your actual attendance data here
            };
            console.log(payload)
    
            // Make the API call using fetch
            const response = await fetch(endpoint, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });
    
            // Parse the response
            const result = await response.json();
    
            // Check if the response is not OK
            if (!response.ok) {
                console.error("Error:", result);
                return alert(`Error: ${result.error || "Something went wrong."}`);
            }
    
            // Handle success
            navigate(-1);
        } catch (error) {
            // Handle errors
            console.error("Fetch error:", error);
            alert("An error occurred while updating attendance. Please try again.");
        } finally {
            // Stop the loading state
            isLoading(false);
        }
    };
    
    return (
        <div className="attendance_page">
            <div className="mainAttendanceHeader">
                <div className="title">
                    <span className="date">{getDelawareDate()}</span>
                    <span className="courseName">{location.state.courseName}</span>
                </div>
                <div onClick={() => navigate(-1)} className="back_arrow">
                    <IoArrowBackOutline />
                </div>
                <div className="profile_icon">
                    <img src={icon} alt="" srcset="" />
                </div>
                <div className="cummulation_attendance">
                    <div className="total_present">
                        <span className="quantity_1" style={{ color: "green" }}>
                            {attendanceData.filter((item) => item.status === "present").length}
                        </span>
                        <span className="unit_1">Present</span>
                    </div>
                    <div className="total_absent">
                        <span className="quantity_1" style={{ color: "red" }}>
                            {attendanceData.filter((item) => item.status === "absent").length}
                        </span>
                        <span className="unit_1">Absent</span>
                    </div>
                </div>
            </div>
            <div className="studentsList">
                <div className="attendanceTabHeading">
                    <span className="studentNameHeading">Student Name</span>
                    <span className="studentRollHeading">Roll No.</span>
                    <span className="studentStatusHeading">Status</span>
                </div>
                {attendanceData.map((item) => {
                    return (
                        <div className="attendanceTab" key={item.rollNo}>
                            <span className="studentName"> <span className={item.invoiceStatus==="paid"?"paid":"unpaid"}></span> {item.name}</span>
                            <span className="studentRoll">
                                <div className="roll_no">{getLastThreeDigits(item.rollNo)}</div>
                            </span>
                            <span className={`studentStatus ${item.status === "present" ? 'present' : 'absent'}`}>
                                <ToggleSwitch
                                    id={`toggle-switch-${item.rollNo}`}
                                    checked={item.status === "present"} // Sync toggle with student's status
                                    onChange={() => handleToggle(item.rollNo)} // Toggle status on change
                                />
                            </span>
                        </div>
                    );
                })}
            </div>
            <button className="updateButton" onClick={()=>{updateAttendance()}}>
                Confirm & Submit Attendance
            </button>
            {loading && <Loader/>}
           {/* <Footer/> */}
        </div>
    );
}